import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { PageHeader, Card, StatusPill, EmptyState, AtomBadge } from "../components/primitives";
import { formatNGN } from "../lib/format";

export default function ReportingSTR() {
  const [strs, setStrs] = useState([]);
  useEffect(() => { api.get("/reports/str").then(r => setStrs(r.data.strs || [])); }, []);
  return (
    <div>
      <PageHeader
        title="Regulatory Reporting — STR"
        subtitle="Suspicious Transaction Reports · NFIU format"
        sections={["5.8"]}
        atom={<AtomBadge model="Atom Nucleus" version="v3.5" description="STR narrative drafting" />}
      />
      <div className="p-6">
        <div className="grid grid-cols-4 gap-3 mb-4">
          <div className="bg-bg-surface border border-line rounded-md p-3"><div className="text-[10px] text-ink-subtle uppercase">STRs filed this month</div><div className="text-[22px] font-medium tabular">47</div></div>
          <div className="bg-bg-surface border border-line rounded-md p-3"><div className="text-[10px] text-ink-subtle uppercase">Acknowledged by NFIU</div><div className="text-[22px] font-medium tabular text-risk-low">41</div></div>
          <div className="bg-bg-surface border border-line rounded-md p-3"><div className="text-[10px] text-ink-subtle uppercase">In draft</div><div className="text-[22px] font-medium tabular">3</div></div>
          <div className="bg-bg-surface border border-line rounded-md p-3"><div className="text-[10px] text-ink-subtle uppercase">Overdue</div><div className="text-[22px] font-medium tabular text-risk-high">0</div></div>
        </div>
        <Card>
          <table className="dense w-full">
            <thead><tr><th>STR ID</th><th>Subject</th><th>Drafted</th><th>Filed</th><th>NFIU reference</th><th>Status</th><th className="text-right">Amount</th><th>MLRO</th></tr></thead>
            <tbody>
              {strs.map(s => (
                <tr key={s.id}>
                  <td><Link to={`/reporting/str/${s.id}`} data-testid={`str-row-${s.id}`} className="text-amber-600 font-medium hover:underline">{s.id}</Link></td>
                  <td className="text-[12px]">{s.subject}</td>
                  <td className="text-[11px]">{s.drafted}</td>
                  <td className="text-[11px]">{s.filed || '—'}</td>
                  <td className="text-[11px] hash-mono">{s.nfiu_ref || '—'}</td>
                  <td><StatusPill status={s.status} /></td>
                  <td className="text-right">{formatNGN(s.amount, {short:true})}</td>
                  <td className="text-[11px]">{s.mlro}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {strs.length === 0 && <EmptyState />}
        </Card>
      </div>
    </div>
  );
}
